import { Component } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'demo-global-message',
  standalone: true,
  imports: [],
  templateUrl: './demo-global-message.component.html',
  styleUrl: './demo-global-message.component.scss',
})
export class DemoGlobalMessageComponent {
  GlobalMessageType = GlobalMessageType;

  constructor(private globalMessage: GlobalMessageService) {}

  alert(text: string, type: GlobalMessageType, duration: number = 5000) {
    this.globalMessage.add(text, type, duration);
  }
}
